// extracted by mini-css-extract-plugin
export default {"Card":"NewAdForm_Card__HjR-s"};